import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/request/parkingHistory";

export default class PreviousRequestsService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
